module.exports = __webpack_public_path__ + "static/media/dualPalpation_mobile.751be13c.jpg";